import { render, staticRenderFns } from "./CompanyHome.vue?vue&type=template&id=12fb609d&scoped=true&"
import script from "./CompanyHome.vue?vue&type=script&lang=js&"
export * from "./CompanyHome.vue?vue&type=script&lang=js&"
import style0 from "./CompanyHome.vue?vue&type=style&index=0&id=12fb609d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fb609d",
  null
  
)

export default component.exports